import { textWithHTML, percentage } from 'Data/format.js'

export function getText(card_fee_percent) {
  return textWithHTML(
    `A <b>platform fee of ${percentage(
      card_fee_percent
    )}</b> will be applied to this card payment. <b>Pease note:</b> This fee may not be considered an eligible expense under a tax-advantaged account. Our system is designed to exclude this fee for Health Savings Account (HSA), Flexible Spending Account (FSA), Health Reimbursement Arrangement (HRA),and insurance reimbursement cards. However, some may not be excluded due to inconsistencies in how issuing banks categorize certain cards.`
  )
}
